export default {
  borderRadius: '0',
};
